<script lang="ts" setup>
import type {
    ContactsContact,
    ContactsCallCentrum,
} from '~~/server/api/insurance/bank/insurance'

export interface PagesBankInsuranceContactsProps {
    data: ContactsContact[] | ContactsCallCentrum[]
    headingLevel?: HeadingLevel
}
const props = withDefaults(defineProps<PagesBankInsuranceContactsProps>(), {
    headingLevel: 'h4',
})
</script>
<template>
  <div class="row justify-content-center">
    <div
      v-for="(item, index) in props.data"
      :key="`bici-${index}`"
      class="col-12 col-md-4 col-lg-3 mb-2 mb-md-6"
    >
      <article
        class="rounded bg-white p-3 px-md-5 py-md-11 h-100 box-shadow-1"
      >
        <img
          :src="item.icon.path"
          width="28"
          height="28"
          loading="lazy"
          decoding="async"
          alt=""
          class="d-block mb-3"
        >
        <Heading
          v-if="!item.subtitle"
          :level="props.headingLevel"
          class="zeta mb-3"
        >
          {{ item.title }}
        </Heading>
        <template v-else>
          <p class="text-secondary fs-small fw-bold">
            {{ item.title }}
          </p>
          <Heading
            v-if="item.subtitle !== undefined"
            :level="props.headingLevel"
            class="zeta mb-1"
          >
            {{ item['subtitle'] }}
          </Heading>
        </template>
        <div
          v-for="(number, index5) in item.contacts"
          :key="`cccn-${index5}`"
        >
          <Typo v-if="number.text_before_availability">
            <p class="text-black fs-small mb-3">
              {{ number.text_before_availability }}
            </p>
          </Typo>
          <template v-if="number.availability">
            {{ number.availability }}:
          </template>
          <a
            class="d-inline-block mb-4"
            :href="`tel:${number.number}`"
          >
            {{ number.number }}
          </a>
        </div>
      </article>
    </div>
  </div>
</template>
